export const FORM_SEARCH = ({ options = [], onSubmitSearch }: any) => {
  return [
    {
      ref: "search_id",
      name: "search_id",
      id: "search_id",
      type: "INPUT",
      label: "หมายเลขเครื่องตัด",
      placeholder: "ตัวอย่าง TG1234567890",
      span: 12,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_pl",
      name: "search_pl",
      label: "หมายเลขรหัส PL",
      type: "INPUT",
      placeholder: "ตัวอย่าง PL22040304",
      span: 12,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_status_device",
      name: "search_status_device",
      label: "สถานะ",
      type: "SELECT",
      span: 12,
      onEnter: onSubmitSearch,
      properties: {
        options: options,
        valueKey: "value",
        labelKey: "label",
      },
    },
  ];
};

export const FORM_EDIT_DATA = ({ options = [], customerCode = "" }: any) => {
  const hasCustomerCode = !!(customerCode && String(customerCode).trim());
  return [
    {
      ref: "remark",
      name: "remark",
      id: "remark",
      type: "TEXTAREA",
      label: "หมายเหตุ",
      placeholder: "ตัวอย่าง เครื่องชำรุด",
      span: 24,
    },
    {
      ref: "customerCode",
      name: "customerCode",
      id: "customerCode",
      type: "TEXTAREA",
      label: "รหัสลูกค้า",
      placeholder: "รหัสลูกค้า",
      span: 24,
    },
    {
      ref: "deviceStatusId",
      name: "deviceStatusId",
      id: "deviceStatusId",
      label: "สถานะ",
      type: "SELECT",
      span: 24,
      properties: {
        options: options,
        valueKey: "value",
        labelKey: "label",
      },
      rules: {
        required: {
          value: true,
          message: "กรุณาเลือกสถานะ",
        },
      },
    },
    {
      ref: "proxy",
      name: "proxy",
      id: "proxy",
      label: "Proxy",
      type: "SELECT",
      span: 12,
      hidden: true,
      properties: {
        options: [
          { typeName: "Chinese", typeId: "Chinese" },
          { typeName: "Proxy", typeId: "Proxy" },
          { typeName: "App", typeId: "App" },
        ],
        valueKey: "typeId",
        labelKey: "typeName",
      },
      rules: {
        required: {
          value: true,
          message: "กรุณาเลือกProxy",
        },
      },
    },
    {
      ref: "bluetooth",
      name: "bluetooth",
      id: "bluetooth",
      label: "Bluetooth",
      type: "RADIO",
      span: 12,
      properties: {
        options: [
          { label: "Yes", value: "YES" },
          { label: "No", value: "NO" },
        ],
        valueKey: "value",
        labelKey: "label",
      },
      rules: {
        required: {
          value: true,
          message: "กรุณาเลือกBluetooth",
        },
      },
    },
    {
      ref: "isAvailable",
      name: "isAvailable",
      id: "isAvailable",
      label: "เปิด-ปิดใช้งาน",
      type: "RADIO",
      span: 12,
      disabled: true,
      properties: {
        options: [
          { label: "เปิด", value: true },
          { label: "ปิด", value: false },
        ],
        valueKey: "value",
        labelKey: "label",
      },
    },
    {
      ref: "lotMonth",
      name: "lotMonth",
      id: "lotMonth",
      type: "DATEPICKER",
      label: "Lot/เดือน",
      placeholder: hasCustomerCode ? "เลือกเดือน" : "กรุณากรอกรหัสลูกค้าก่อน",
      format: "YYYY/MM",
      span: 12,
      disabled: !hasCustomerCode,
      properties: {
        picker: "month",
      },
    },
  ];
};
